import { Routes } from '@angular/router';
import { PORTAL_ROUTES } from './portal.constants';

export const portalRoutes: Routes = [
    {
        path: PORTAL_ROUTES.ROOT,
        loadComponent: () => import('./portal-content').then((m) => m.PortalContent),
        data: { breadcrumb: 'Portal' },
        children: [
            { path: '', redirectTo: PORTAL_ROUTES.PROFILE, pathMatch: 'full' },
            { path: PORTAL_ROUTES.PROFILE, loadComponent: () => import('./dashboard-profile/dashboard-profile').then((m) => m.DashboardProfile), data: { breadcrumb: 'Perfil' } }
        ]
    }
];
